import React, { useRef } from 'react';
import {
  Button,
  Modal,
  ModalContent,
  ModalCloseButton,
  ModalBody,
  Flex,
  Box,
} from '@chakra-ui/react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { Navigation, Pagination } from 'swiper/modules';
import './imageSliderPopup.css';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faChevronLeft,
  faChevronRight,
} from '@fortawesome/pro-regular-svg-icons';
import { XMarkIcon } from '@heroicons/react/16/solid';

export default function ImageSliderModal({
  isOpen,
  closeModal,
  media,
  initialSlide = 0,
  updateCurrentSlideIndex,
  activePlotId,
}) {
  const swiperRef = useRef(null);

  return (
    <Modal isOpen={isOpen} onClose={closeModal} size={'full'} padding="0">
      <Button
        variant={'solid'}
        position={'absolute'}
        right={3}
        top={3}
        p={5}
        background={'primary.bg.default'}
        rounded={'full'}
        onClick={closeModal}
        zIndex={123}
        border="none"
        outline="none"
        _hover={{
          bg: 'primary.bg.darker',
        }}
      >
        <XMarkIcon width={16} height={16} />
      </Button>
      <ModalContent>
        <Box>
          <ModalCloseButton
            zIndex={2}
            background={'primary.bg.default'}
            rounded={'full'}
            p={5}
            _hover={{
              bg: 'primary.bg.darker',
            }}
          />
        </Box>
        <ModalBody padding={0} background="black">
          <Box position="relative" padding={0}>
            {
              <Swiper
                ref={swiperRef}
                modules={[Navigation, Pagination]}
                slidesPerView={1}
                initialSlide={initialSlide}
                navigation={{
                  nextEl: '.image-slider-swiper-next',
                  prevEl: '.image-slider-swiper-prev',
                }}
                pagination={{ clickable: true }}
                onSwiper={(swiper) => (swiperRef.current = swiper)}
                onSlideChange={(swiper) => {
                  updateCurrentSlideIndex(swiper.activeIndex);
                }}
                style={{ width: '100%', height: '100vh' }}
              >
                {media.map((media) => (
                  <SwiperSlide
                    key={`${media.id}-${media.url}-${activePlotId}`}
                    style={{ padding: 0, width: '100%' }}
                  >
                    <img
                      src={media.url}
                      width="100%"
                      height="100%"
                      className="img-contain"
                      alt=""
                      loading="eager"
                      fetchPriority="high"
                    />
                  </SwiperSlide>
                ))}
              </Swiper>
            }
            {media && media.length > 1 && (
              <Flex
                alignItems="center"
                justifyContent="space-between"
                position="absolute"
                width="100%"
                height="100%"
                inset={0}
                zIndex={1}
              >
                <PrevButton />
                <NextButton />
              </Flex>
            )}
          </Box>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}

function NextButton() {
  return (
    <Button
      className="image-slider-swiper-next"
      zIndex={2}
      height="100%"
      width="4.1rem"
      alignItems="center"
      justifyContent={'center'}
      background="linear-gradient(to right, transparent, rgb(0,0,0,.75))"
      cursor="pointer"
      position="absolute"
      right={0}
      borderRadius={0}
    >
      <FontAwesomeIcon
        icon={faChevronRight}
        fontSize="1.125rem"
        color="white"
      />
    </Button>
  );
}

function PrevButton() {
  return (
    <Button
      className="image-slider-swiper-prev"
      zIndex={2}
      height="100%"
      width="4.1rem"
      alignItems="center"
      justifyContent={'center'}
      background="linear-gradient(to left, transparent, rgb(0,0,0,.75))"
      cursor="pointer"
      position="absolute"
      left={0}
      borderRadius={0}
    >
      <FontAwesomeIcon icon={faChevronLeft} fontSize="18px" color="white" />
    </Button>
  );
}

ImageSliderModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  media: PropTypes.array,
  initialSlide: PropTypes.number,
  updateCurrentSlideIndex: PropTypes.func,
  activePlotId: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.oneOf([null]),
  ]),
};
